import { render, staticRenderFns } from "./BasicOperationsReport.vue?vue&type=template&id=00df6b98"
import script from "./BasicOperationsReport.vue?vue&type=script&lang=js"
export * from "./BasicOperationsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports